import type { AppointmentTooltip } from '@devexpress/dx-react-scheduler';
import React from 'react';

import Icon from '@components/Icon/Icon';

import { CommandButtonWrapper } from './AppointmentTooltip.style';

/**
 * VITALL-styled button component for a routine's tooltip
 */
const CommandButton = ({ ...props }: AppointmentTooltip.CommandButtonProps) => {
  const { id, onExecute } = props;
  switch (id) {
    case 'close':
      return (
        <CommandButtonWrapper>
          <Icon
            clickable
            color="text.secondary"
            name="xmark"
            onClick={onExecute}
            type="far"
          />
        </CommandButtonWrapper>
      );
    case 'open':
      return (
        <CommandButtonWrapper>
          <Icon
            clickable
            color="text.secondary"
            name="pen"
            onClick={onExecute}
          />
        </CommandButtonWrapper>
      );
    case 'delete':
    default:
      return null;
  }
};

export default CommandButton;
